import store from '@/store/store';

export class EmployerIds {
    public static ae: string = '00';
    public static qualityAtSpeed: string = '01';
}

export class GeneralConstants {
    public static skilldUrl: string;
    public static get skilldProfileUrl() {
        return `${store.state.root._links.skilld.href}/#/profile/email/`;
    }
    public static capacityPlanUrl: string;
    public static get capacityPlanSearchUrl() {
        return `${store.state.root._links.capacityPlan.href}?q=`;
    }
}
